import { useTabActive } from '@wix/wix-chatbot-common/hooks';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectChatSessionState } from '../../common/selectors/chat';
import { markAsRead } from '../api/messageApi';

export const useMarkAsReadOnTabChange = () => {
  const isTabActive = useTabActive();
  const { conversationId, lastMessageId, unreadCount } = useSelector(selectChatSessionState);

  useEffect(() => {
    if (isTabActive) {
      if (!conversationId || !lastMessageId || unreadCount === 0) {
        return;
      }
      markAsRead(conversationId, lastMessageId);
    }
  }, [isTabActive]);
};
